const ProductCurve = ({ color }) => (
  <svg className="product-curve" xmlns="http://www.w3.org/2000/svg" viewBox="0 -36 400 400">
    <path className={`bg-fill-${color}`} fillRule="evenodd"
      d="M.013 38.986C.02 61.643 10.814 87.16 42.035 114.77c57.729 51.44-46.816 149.565-9.183 216.596 30.86 55.14 118.093-2.819 244.69-15.503C354.39 308.2 400 364 400 364H0V-36c0 23.333.004 48.329.013 74.986Z" />
  </svg>
);

export default ProductCurve;
